import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { RolesService } from '../../infrastructure/services/roles.service';
import { Observable } from 'rxjs/Observable';
import { Role } from 'app/infrastructure/model/classes/role.class';
import { AuthService } from "app/infrastructure/services/auth.service";
import { SxSecurityService } from 'app/infrastructure/services/sxSecurity.service';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';

@Component({
  selector: 'sx-listado-roles',
  templateUrl: './listado.rol.component.html',
})
export class ListadoRolComponent implements OnInit {
  codSistema: string;
  codNegocio: string;
  urlAdicional: string;
  roles: Role[];
  buscar: any;

  constructor(
    private rolesService: RolesService,
    private aRoute: ActivatedRoute,
    private _router: Router,
    private _authService: AuthService,
    private _securityService: SxSecurityService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];

      if(this.codNegocio == undefined &&
        this.codSistema == undefined){
          this.codSistema = 'null';
          this.codNegocio = 'null';
        }

      this.rolesService.getRolesByContext(this.codSistema, this.codNegocio)
        .subscribe((response: Role[]) => {
          this.roles = response;
        });
    });
  }


  toogleStatus(role: Role) {
    // TODO: Change this to get the current user in the service layer
    let currentUserName = '';
    this._authService.currentUser.map(c => currentUserName = c.name);
    const isEnable = role.status === Role.statusEnable;
    const changeStatusRole = isEnable ?
      this.rolesService.disableRole(role, currentUserName) : this.rolesService.enaleRole(role, currentUserName);
    changeStatusRole.subscribe((response) => {
      role.status = isEnable ? Role.statusDisable : Role.statusEnable;
    });
  }

  updateDynamicSecAttr() {
    this._securityService.updateDynamicSecAttr(this.codSistema, this.codNegocio)
      .subscribe(
        data => {
          this.alertService.showGrowl({
            body: 'SUCCESS_UPDATE_DYN_SECURITY_ATTR',
            type: GrowlType.SUCCESS,
          });
        },
        error => {
          this.alertService.showGrowl({
            body: error,
            type: GrowlType.DANGER,
          });
        }
      )
  }
  
  volver() {
    this._router.navigate(['../'], { relativeTo: this.aRoute });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/rol/listado.rol.component.ts